interface LogoProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  width?: number | string;
  height?: number | string;
  className?: string;
}

export default function Logo({ width = 32, height = 32, className, ...props }: LogoProps) {
  return (
    <img
      src="/logo.svg"
      alt="Logo"
      width={width}
      height={height}
      className={className}
      {...props}
    />
  );
}
